export enum IDeviationType {
  Mooring = 0,
  Locality = 1,
  Position = 2,
  Equipment = 3,
  MainComponent = 4,
  LocalityFrequency = 5,
  Task = 6,
  Maintenance = 7,
}
